// extracted by mini-css-extract-plugin
export var cardContainer = "_n9-0";
export var cardHeader = "_n9-2";
export var collapsedState = "_n9-3";
export var dragHandle = "_n9-5";
export var dragHandleIcon = "_n9-6";
export var dragging = "_n9-1";
export var titleArea = "_n9-4";